<template>
  <v-app>
    <Notifier ref="notifier" />
    <router-view />
  </v-app>
</template>

<script>
import Notifier from '@/components/Notifier.vue'

export default {
  name: 'App',
  components: { Notifier }
}
</script>
